import { useState } from 'react'
import { useAppSelector } from '../../hooks/redux'
import { ColleaguesList } from './colleagues-list.component'

export function WithPaginationColleagues() {
  const colleagues = useAppSelector((state) => state.colleagues)
  const [currentPage, setCurrentPage] = useState<number>(1)

  const paginatedColleagues = colleagues.slice((currentPage - 1) * 5, currentPage * 5)

  const handleNext = () => {
    if (currentPage < Math.ceil(colleagues.length / 5)) {
      setCurrentPage(currentPage + 1)
    }
  }

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1)
    }
  }

  return (
    <>
      <ColleaguesList colleagues={paginatedColleagues} />
      <div className='button-wrapper flex justify-between items-center'>
        <button
          onClick={handlePrev}
          className='bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded'
          data-testid='col-prev'
        >
          prev
        </button>
        <p data-testid='col-page'>page: {currentPage}</p>
        <button
          onClick={handleNext}
          className='bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded'
          data-testid='col-next'
        >
          next
        </button>
      </div>
    </>
  )
}
